import { SlideshowSelectEvent } from '@theme/events';
import { prefersReducedMotion } from '@theme/utilities';

/**
 * Custom entrance animation for the hero slideshow's incoming slide image,
 * replicating a GSAP-style snap-back: the image starts over-stretched
 * horizontally, offset, slightly rotated, and invisible, then animates back
 * to its resting state. Scoped to the hero section only (matched by id
 * suffix, since Shopify prefixes JSON-template section ids with a
 * store/template-specific segment) so the mid-page promo slideshow is
 * unaffected.
 */
function initHeroSlideTransition() {
  const heroSection = document.querySelector('[id$="__hero_jVaWmY"]');
  const slideshow = heroSection?.querySelector('slideshow-component');
  if (!slideshow) return;

  let skipNext = true; // the first select event fires on mount; don't animate the initial slide

  slideshow.addEventListener(SlideshowSelectEvent.eventName, (event) => {
    if (skipNext) {
      skipNext = false;
      return;
    }

    if (prefersReducedMotion()) return;

    const slide = /** @type {CustomEvent} */ (event).detail?.slide;
    const wrapper = slide?.querySelector('.slide__image-container');
    if (!(wrapper instanceof HTMLElement)) return;

    wrapper.getAnimations().forEach((anim) => anim.cancel());
    wrapper.style.willChange = 'transform, opacity';

    const animation = wrapper.animate(
      [
        { transform: 'translate(30%, 0%) rotate(-1deg) scale(2.8, 1)', opacity: 0 },
        { transform: 'translate(0%, 0%) rotate(0deg) scale(1, 1)', opacity: 1 },
      ],
      { duration: 900, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'both' }
    );

    animation.addEventListener('finish', () => {
      wrapper.style.willChange = '';
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroSlideTransition);
} else {
  initHeroSlideTransition();
}
